export const carouselInicio = [
   {
      "imagen" : "videos/Hidalgo Unido1.gif",
   },  
 
 
]